@if (loader.isLoading()) {
  <div
    class="fixed top-0 left-0 h-[3px] bg-primary z-[9999] transition-all duration-300"
    [style.width]="loader.isLoading() ? '100%' : '0%'"
    [class.animate-loader]="loader.isLoading()"
  ></div>
}
